module.exports = __webpack_public_path__ + "static/student_loans_icon-7e810a1db0c20082439c58f03ae73e47.png";